module.exports = __webpack_public_path__ + "img/managed.4283a82e.svg";